import { StackedBarList } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type Props = {
  promotionsByTeam: {
    label: string
    values: {
      label: string
      value: number
    }[]
    total: number
  }[]
}

const PromotionsByTeamChart = ({ promotionsByTeam }: Props) => {
  return (
    <StackedBarList
      leftColumnHeader={i18n.t('insights.widgets.approved_promotions.team_header')}
      rightColumnHeader={i18n.t('insights.widgets.approved_promotions.requests_header')}
      data={promotionsByTeam}
    />
  )
}

export default PromotionsByTeamChart
